var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import classNames from "classnames";
import { artActionNoOverflowCls } from "../../action/Action.less";
import { artOptionFrameCls, artOptionFrameDescriptionCls } from "./Frame.less";
function ArtFrameDescription(_ref) {
  var isFramed = _ref.isFramed, readyToHang = _ref.readyToHang, disableHint = _ref.disableHint, Hint = _ref.hint, translations = _ref.translations;
  if (!isFramed && !readyToHang) {
    return null;
  }
  var texts = {};
  if (isFramed && !readyToHang) {
    texts = {
      label: translations.shipsFramed,
      title: translations.shipsFramedTooltipHeading,
      description: translations.shipsFramedTooltipDescription
    };
  } else if (!isFramed && readyToHang) {
    texts = {
      label: translations.readyToHang,
      title: translations.readyToHangTooltipHeading,
      description: translations.readyToHangTooltipDescription
    };
  } else {
    texts = {
      label: translations.shipsFramedAndReadyToHang,
      title: translations.shipsFramedTooltipHeading,
      description: translations.shipsFramedTooltipDescription
    };
  }
  var hintContent = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, texts.title), /* @__PURE__ */ React.createElement("p", null, texts.description));
  return /* @__PURE__ */ React.createElement("div", {
    className: artOptionFrameCls
  }, /* @__PURE__ */ React.createElement("span", {
    className: classNames(artOptionFrameDescriptionCls, artActionNoOverflowCls)
  }, texts.label, !disableHint ? /* @__PURE__ */ React.createElement(Hint, {
    type: "hint",
    padded: true,
    wrapperTag: "span",
    showOnClick: true,
    text: hintContent
  }) : null));
}
__name(ArtFrameDescription, "ArtFrameDescription");
export {
  ArtFrameDescription
};
